import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, isStaff } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";
import { apiErr } from "@/lib/api";
import AuthShell from "./AuthShell";
import { Field, Input } from "@/components/Field";
import GoogleButton from "@/components/GoogleButton";

export default function Register() {
  const { t, lang } = useI18n();
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "";
  const [f, setF] = useState({ first_name: "", last_name: "", company: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register({ ...f, language: lang });
      toast.success("Konto erstellt!");
      nav(isStaff(u) ? "/admin" : (next || "/portal"));
    } catch (err) { toast.error(apiErr(err)); }
    setLoading(false);
  };
  return (
    <AuthShell title={t("auth.registerTitle")}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="grid grid-cols-2 gap-3">
          <Field label={t("auth.firstName")}><Input testid="reg-first" required value={f.first_name} onChange={set("first_name")} /></Field>
          <Field label={t("auth.lastName")}><Input testid="reg-last" required value={f.last_name} onChange={set("last_name")} /></Field>
        </div>
        <Field label={t("auth.company")}><Input testid="reg-company" value={f.company} onChange={set("company")} /></Field>
        <Field label={t("common.email")}><Input testid="reg-email" type="email" required value={f.email} onChange={set("email")} /></Field>
        <Field label={t("auth.phone")}><Input testid="reg-phone" value={f.phone} onChange={set("phone")} /></Field>
        <Field label={t("auth.password")}><Input testid="reg-password" type="password" required minLength={6} value={f.password} onChange={set("password")} /></Field>
        <button className="btn-primary w-full" disabled={loading} data-testid="register-submit">{loading ? "…" : t("nav.register")}</button>
      </form>
      <GoogleButton next={next} />
      <p className="text-sm text-muted-foreground mt-6 text-center">{t("auth.hasAccount")} <Link to={`/login${next ? `?next=${encodeURIComponent(next)}` : ""}`} className="text-primary font-semibold" data-testid="register-login-link">{t("nav.login")}</Link></p>
    </AuthShell>
  );
}
